import * as Actions from "./constants.js";

const initialState = {
  loading: false, 
  subscription: null, 
  createError: null, 
};

export default function SendNotificationsReducer(state = initialState, action) {
  switch (action.type) {
    case Actions.SEND_NOTIFICATION:
      return {
        ...state,
        loading: true, 
      };
    case Actions.SEND_NOTIFICATION_SUCCESS:
      return {
        ...state,
        subscription: action.payload,
        loading: false, 
      };
    case Actions.SEND_NOTIFICATION_ERROR:
      return {
        ...state,
        createError: action.error,
        loading: false,
      };
      case Actions.CLEAR_NOTIFICATION_ERROR:
      return {
        ...state,
        createError: null,
      };
    case Actions.CLEAR_NOTIFICATION_SUCCESS:
      return {
        ...state,
        subscription: null, 
      };
    default:
      return state;
  }
}
